<div class="z-10 w-full flex justify-center h-28 mt-4" [style.marginBottom]="mobile ? '2.5rem' : '6rem'"  id="card-page-container">

      <!--   Hidden form for form post to BankServ   -->
      <ng-container *ngIf="initiateResponseCard">
        <form [action]="initiateResponseCard.acsUrl" method="post" id="acs-form" class="cdk-visually-hidden" hidden>
          <input name="MD" [value]="initiateResponseCard.acsMD" id="MD" hidden>
          <input name="PaReq" [value]="initiateResponseCard.acsPayload" id="PaReq" hidden>
          <input name="TermUrl" [value]="initiateResponseCard.acsTermUrl" id="TermUrl" hidden>
        </form>
      </ng-container>

      <div class="background-image background-cover block z-50">
        <div class="card-container">
          <div class="card-card">
            <div class="flipper box" id="credit__card">
<!--              style="transform: translateY(12px) !important;"-->
<!--              [ngStyle]="{'transform': navigated ? 'translateY(0px)' : ''}"-->
              <div class="front side" id="credit__card__front" [attr.style]="navigated ? 'transform: translateY(16px) !important' : 'transform: translateY(16px) !important'" >
                <div
                  id="ccsingle"
                  class="cardTypeSvg"
                  [attr.style]="mobile ? 'margin-top: 10px !important; margin-right: 0px !important' : 'margin-top: 22x !important; margin-right: 10px !important'"
                >
                </div>
                <svg class="hpx-150 sm:hpx-200" version="1.1" id="cardfront" xmlns="http://www.w3.org/2000/svg"
                     x="0px" y="0px" viewBox="0 0 750 471" style="enable-background:new 0 0 750 471;" xml:space="preserve">
                    <g id="Front">
                        <g id="CardBackground">
                            <g id="Page-1_1_">
                                <g id="amex_1_">
                                    <path id="Rectangle-1_1_" class="lightcolor grey" d="M40,0h670c22.1,0,40,17.9,40,40v391c0,22.1-17.9,40-40,40H40c-22.1,0-40-17.9-40-40V40
                            C0,17.9,17.9,0,40,0z" />
                                </g>
                            </g>
                          <path class="darkcolor greydark" d="M750,431V193.2c-217.6-57.5-556.4-13.5-750,24.9V431c0,22.1,17.9,40,40,40h670C732.1,471,750,453.1,750,431z" />
                        </g>
                      <text transform="matrix(1 0 0 1 60.106 295.0121)" id="svgnumber" class="st2 st3 st4">{{ cardNumberControl.value ? cardNumberControl.value : '0123 4567 8910 1112' }}</text>
                      <text transform="matrix(1 0 0 1 54.1064 428.1723)" id="svgname" class="st2 st5 st6">{{ cardHolderControl.value ? cardHolderControl.value.length > 22 ? cardHolderControl.value.slice(0, 22) + '...' : cardHolderControl.value  : 'JOHN DOE' }}</text>
                      <text transform="matrix(1 0 0 1 54.1074 389.8793)" class="st7 st5 st8">cardholder name</text>
                      <text transform="matrix(1 0 0 1 479.7754 388.8793)" class="st7 st5 st8">expiration</text>
                      <text transform="matrix(1 0 0 1 65.1054 241.5)" class="st7 st5 st8">card number</text>
                      <g>
                            {{ cardExpiryYearControl.value }}
                            <text transform="matrix(1 0 0 1 574.4219 433.8095)" id="svgexpire" class="st2 st5 st9">{{ cardExpiryMonthControl.value ? cardExpiryMonthControl.value : '01' }}/{{ cardExpiryMonthControl.value && cardExpiryYearControl.value ? (cardExpiryYearControl.value.toString())[2] + (cardExpiryYearControl.value.toString())[3] : cardExpiryMonthControl.value ? '' : '23' }}</text>
                        <text transform="matrix(1 0 0 1 479.3848 417.0097)" class="st2 st10 st11">VALID</text>
                        <text transform="matrix(1 0 0 1 479.3848 435.6762)" class="st2 st10 st11">THRU</text>
                        <polygon class="st2" points="554.5,421 540.4,414.2 540.4,427.9 		" />
                      </g>
                    </g>
                  <g id="Back">
                    </g>
                </svg>
              </div>
              <div class="back side" id="credit__card__back" [attr.style]="navigated ? 'transform: translateY(0px) !important' : 'transform: translateY(16px) !important'">
                <svg class="hpx-150 sm:hpx-200" version="1.1" id="cardback" xmlns="http://www.w3.org/2000/svg"
                     x="0px" y="0px" viewBox="0 0 750 471" style="enable-background:new 0 0 750 471;" xml:space="preserve">
                    <g id="Front">
                        <line class="st0" x1="35.3" y1="10.4" x2="36.7" y2="11" />
                    </g>
                  <g id="Back">
                        <g id="Page-1_2_">
                            <g id="amex_2_">
                                <path id="Rectangle-1_2_" class="darkcolor greydark" d="M40,0h670c22.1,0,40,17.9,40,40v391c0,22.1-17.9,40-40,40H40c-22.1,0-40-17.9-40-40V40
                        C0,17.9,17.9,0,40,0z" />
                            </g>
                        </g>
                    <rect y="61.6" class="st2" width="750" height="78" />
                    <g>
                            <path class="st3" d="M701.1,249.1H48.9c-3.3,0-6-2.7-6-6v-52.5c0-3.3,2.7-6,6-6h652.1c3.3,0,6,2.7,6,6v52.5
                    C707.1,246.4,704.4,249.1,701.1,249.1z" />
                      <rect x="42.9" y="198.6" class="st4" width="664.1" height="10.5" />
                      <rect x="42.9" y="224.5" class="st4" width="664.1" height="10.5" />
                      <path class="st5" d="M701.1,184.6H618h-8h-10v64.5h10h8h83.1c3.3,0,6-2.7,6-6v-52.5C707.1,187.3,704.4,184.6,701.1,184.6z" />
                        </g>
                        <!-- [imask]="{ mask: '***' }" -->
                    <text  transform="matrix(1 0 0 1 621.999 227.2734)" id="svgsecurity" class="st6 st7" *ngIf="cvvRequired">{{ cardCVVControl.value ? ((cardCVVControl.value)[0] && !(cardCVVControl.value)[1] ? '*' : (cardCVVControl.value)[0] && (cardCVVControl.value)[1] && !(cardCVVControl.value)[2] ? '**' : '***') : '000' }}</text>
                    <g class="st8">
                            <text transform="matrix(1 0 0 1 518.083 280.0879)" class="st9 st6 st10">security code</text>
                        </g>
                    <rect x="58.1" y="378.6" class="st11" width="375.5" height="13.5" />
                    <rect x="58.1" y="405.6" class="st11" width="421.7" height="13.5" />
                    <text transform="matrix(1 0 0 1 59.5073 228.6099)" id="svgnameback" class="st12 st13">{{ cardHolderControl.value ? cardHolderControl.value : 'JOHN DOE' }}</text>
                    </g>
                </svg>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="w-full flex flex-col justify-center relative" [ngStyle]="{'bottom': '0%'}" *ngIf="addCardState">

      <input
        hidden
        id="cardnumber-input"
      >

      <form
        [formGroup]="cardForm"
        class="flex flex-wrap justify-center bg-gray-300 pt-6 ml-4 mr-4 mb-2 pb-4"
        style="border-radius: 12px;"
        (keydown.enter)="formSubmit($event)"
      >

        <div class="field-container" #cardNumberForm class="w-full md:w-1/2 flex justify-center">
          <mat-form-field class="w-10/12">
            <mat-label><strong>Card Number</strong></mat-label>
            <input
              [imask]="activeCard ? '' : getCardStyling()"
              id="cardnumber"
              matInput
              [formControl]="cardForm.controls.cardNumber"
              required
              [errorStateMatcher]="matcher"
              (keyup)="styleDynamicCard($event)"
              autocomplete="cc-number"
            >
            <mat-error *ngIf="cardForm.invalid">
              {{ cardNumberError === 'minlength' || cardNumberError === 'maxlength' ? 'Invalid Card Number' : cardNumberError }}
            </mat-error>
            <svg id="ccicon" class="ccicon" viewBox="0 0 750 471" version="1.1"
                 xmlns="http://www.w3.org/2000/svg"
            >
            </svg>
          </mat-form-field>
        </div>

        <div class="field-container" class="w-full md:w-1/2 flex justify-center">
          <mat-form-field class="w-10/12">
            <mat-label><strong>Cardholder's Name</strong></mat-label>
            <input
              type="text"
              matInput
              formControlName="cardHolder"
              required
              autocomplete="cc-name"
              [errorStateMatcher]="matcher"
            >
            <mat-error *ngIf="cardForm.invalid">
              {{ cardHolderError }}
          </mat-error>
          </mat-form-field>
        </div>

        <div class="field-container" class="w-1/3 md:w-1/4 flex justify-center">
          <input
            autocomplete="cc-exp-month"
            class="cdk-visually-hidden"
            tabindex="-1"
            (change)="autoCompleteSelect('month', $event)"
          >
          <input
            class="cdk-visually-hidden"
            (focusin)="matSelectMonth.open()"
          >
          <mat-form-field class="w-10/12">
            <mat-label class="sm:text-base text-sm"><strong>{{ mobile ? 'Month' : 'Expiry Month' }}</strong></mat-label>
            <!--      cc-exp-month        -->
            <!--              autoCompleteSelect('cc-exp-month')-->
            <mat-select
              [(value)]="cardExpiryMonthOpt"
              formControlName="cardExpiryMonth"
              #matSelectMonth
              (selectionChange)="expiryMonthSelected(cardExpiryMonthOpt)"
              required
              [errorStateMatcher]="matcher"
            >
              <mat-option *ngFor="let month of expiryMonths" [value]="month">{{ month }}</mat-option>
            </mat-select>
            <mat-error *ngIf="cardForm.invalid">
              {{ cardExpiryMonthError }}
          </mat-error>
          </mat-form-field>
        </div>

        <div class="field-container" class="w-1/3 md:w-1/4 flex justify-center">
          <input
            autocomplete="cc-exp-year"
            class="cdk-visually-hidden"
            tabindex="-1"
            (change)="autoCompleteSelect('year', $event)"
          >
          <input
            class="cdk-visually-hidden"
            (focusin)="matSelectYear.open()"
          >
          <mat-form-field class="w-10/12">
            <mat-label class="sm:text-base text-sm"><strong>{{ mobile ? 'Year' : 'Expiry Year' }}</strong></mat-label>
            <!--      cc-exp-year        -->
            <mat-select
              [(value)]="cardExpiryYearOpt"
              formControlName="cardExpiryYear"
              #matSelectYear
              (selectionChange)="expiryYearSelected(cardExpiryYearOpt)"
              required
              [errorStateMatcher]="matcher"
            >
              <mat-option *ngFor="let year of expiryYears" [value]="year">{{ year }}</mat-option>
            </mat-select>
            <mat-error *ngIf="cardForm.invalid">
              {{ cardExpiryYearError }}
          </mat-error>
          </mat-form-field>
        </div>

        <div class="field-container" class="w-1/5 md:w-1/4 flex justify-center" *ngIf="cvvRequired">
          <mat-form-field class="w-10/12">
            <mat-label><strong><i>CVV</i></strong></mat-label>
            <input
              type="password"
              minlength="3"
              maxlength="4"
              autocomplete="new-password"
              id="cc"
              name="cc"
              (focusin)="onFocus(true)"
              (focusout)="onFocus($event)"
              (keydown)="onlyNumbers($event, cardForm)"
              matInput
              formControlName="cardCVV"
              required
              [errorStateMatcher]="matcher"
            >
            <mat-error *ngIf="cardForm.invalid">
              {{ cardCVVError }}
          </mat-error>
          </mat-form-field>
        </div>

        <div class="field-container" class="w-2/5 md:w-1/2 flex justify-center" *ngIf="budgetAllowed">
          <mat-form-field class="w-10/12">
            <mat-label class="sm:text-base text-xs"><strong>Payment Period</strong></mat-label>
            <mat-select
              formControlName="cardPaymentPeriod"
              required
              [errorStateMatcher]="matcher"
              [disabled]="loading"
            >
              <mat-option *ngFor="let paymentPeriod of paymentPeriods" [value]="paymentPeriod.code" >{{ paymentPeriod.name }}</mat-option>
            </mat-select>
            <mat-error *ngIf="cardForm.invalid">
              {{ cardPaymentPeriodError }}
            </mat-error>
          </mat-form-field>
        </div>
<!-- Remove email for now until config is added to do emails -->
<!--        <div class="field-container" *ngIf="!loading" class="w-1/2 md:w-1/2 flex justify-center">-->
<!--          <mat-form-field class="w-10/12">-->
<!--            <mat-label><strong>Email</strong></mat-label>-->
<!--            <input-->
<!--              matInput-->
<!--              formControlName="cardConfirmationEmail"-->
<!--              [errorStateMatcher]="matcher"-->
<!--            >-->
<!--            <mat-error *ngIf="cardForm.invalid">-->
<!--              {{ cardConfirmationEmailError }}-->
<!--            </mat-error>-->
<!--          </mat-form-field>-->
<!--        </div>-->

      </form>

      <div>
        <div class="w-full flex justify-center mt-2" style="height: 30px;" *ngIf="!mobile">
          <mat-slide-toggle [disabled]="loading" *ngIf="!activeCard && tokenization && !isCardVerification && !forceTokenization" class="mb-3" color="primary" [(ngModel)]="saveCard">Save Card</mat-slide-toggle>
        </div>
        <div class="flex justify-center" [ngClass]="mobile ? 'flex-col' : 'flex-row-reverse'">
          <div class="flex justify-center items-center flex-col confirm-container mt-2" [ngClass]="mobile ? 'mb-2' : 'mb-4'" *ngIf="!paymentConfirm">
            <button [disabled]="loading && !cardExpiryMonthOpt" class="text-xl text-white font-medium border-solid rounded-lg continue-button pt-2 pb-2 max-w-225 wpx-225 flex justify-center" [ngStyle]="{'background-color': headerColor}" (click)="formValidation()">
              <span *ngIf="!loading">{{ saveCard && !activeCard && !isCardVerification ? 'SAVE & CONTINUE' : 'CONTINUE' }}</span>
              <mat-spinner
                *ngIf="loading"
                class="loading-spinner mb-1 mt-1"
                [color]="color"
                [diameter]="diameterContinue"
              >
              </mat-spinner>
            </button>
          </div>
          <div class="flex justify-center items-center flex-col confirm-container mt-2 mb-4" [ngClass]="mobile ? 'mr-0' : 'mr-4'" *ngIf="!paymentConfirm">
            <button [disabled]="loading" class="text-xl font-medium rounded-lg continue-button px-16 flex items-center" [ngStyle]="{'height': '48px', 'color': 'black',  'border': '3px solid ' + headerColor }" mat-button (click)="cancelTransaction()">
              <p class="p-0 m-0" *ngIf="!transactionCancelled">{{ 'CANCEL' }}</p>
              <mat-spinner
                *ngIf="transactionCancelled"
                class="loading-spinner mb-4 mt-4"
                [color]="color"
                [diameter]="diameterColour"
              >
              </mat-spinner>
            </button>
          </div>
        </div>
        <div class="w-full flex justify-center mt-2" style="height: 30px;" *ngIf="mobile">
          <mat-slide-toggle [disabled]="loading" *ngIf="!activeCard && tokenization && !forceTokenization" class="mb-3" color="primary" [(ngModel)]="saveCard">Save Card</mat-slide-toggle>
        </div>
      </div>

      <div class="w-100 flex justify-center text-center px-4 mat-typography" style="padding-bottom: 5px;">
        <span class="text-xs">You may be redirected to your bank’s secure site to authenticate yourself before making the payment.</span>
      </div>

      <div class="flex flex-wrap justify-center items-center px-8 sm:px-0 mb-16">
        <div *ngIf="cardSchemas" class="flex flex-wrap justify-center items-center sm:mx-32" [ngClass]="cardSchemas.length > 6 ? 'w-full sm:w-auto' : ''">
            <span *ngFor="let cardType of cardSchemas">
              <ng-container *ngIf="cardType.imageName && cardType.imageName.trim() && cardType.imageName.trim().length > 0">
                <img [src]="cardType.imageName" class="w-16 h-12 sm:w-16 sm:h-12" [ngStyle]="{'margin-bottom': cardType.code === 'visa' ? '4px': cardType.code === 'visaElectron' ? '-6px': ''}">
              </ng-container>
            </span>
        </div>
      </div>

    </div>
